import { EventEmitter, Injectable } from '@angular/core';
import { IMLTranslationService } from '../../common/interfaces/IMLTranslationService.interface';
import { TransactionIdLabelTranslation } from './cpq-transaction-id-label-translation-dialog.model';
import { TranslationField, TranslationSection } from '../../cpq-ml-translations/cpq-ml-translations.model';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class TransactionIdLabelTranslationService implements IMLTranslationService<TransactionIdLabelTranslation> {
  private defaultDictionaryId = 0;
  public onSave: EventEmitter<any> = new EventEmitter<any>();
  public onSaveComplete: EventEmitter<any> = new EventEmitter<any>();
  public sourceId: number;
  constructor(private http: HttpClient) { }

  private createTranslationsPayload(translationSections: Array<TranslationSection>): Array<TransactionIdLabelTranslation> {
    const quoteOrderidLabelTranslation = new Array<TransactionIdLabelTranslation>();

    translationSections.forEach(section => {
      section.translationFields.forEach(translationField => {
        for (const key in translationField.translations) {
          if (translationField.translations.hasOwnProperty(key)) {
            const dictionaryId = Number.parseInt(key, 10);
            if (dictionaryId === this.defaultDictionaryId) {
              continue;
            }
            const translatedName = new TransactionIdLabelTranslation();
            translatedName.dictionaryId = dictionaryId;
            translatedName.translatedValue = translationField.translations[dictionaryId];
            quoteOrderidLabelTranslation.push(translatedName);
          }
        }
      });
    });
    return quoteOrderidLabelTranslation;
  }

  public getTranslation(dictionaryId: number): Observable<TransactionIdLabelTranslation> {
    return this.http.get<TransactionIdLabelTranslation>(`api/integrations/v1/cloudIntegration/settings/transactionIdLabel/translations/${dictionaryId}`);
  }

  public saveTranslations(TransactionIdLabelTranslation: Array<TranslationSection>): Observable<void> {
    const payload = JSON.stringify(this.createTranslationsPayload(TransactionIdLabelTranslation));
    return this.http.put<void>(`api/integrations/v1/cloudIntegration/settings/transactionIdLabel/translations`, payload);
  }

  public initTranslationDetails(TransactionIdLabelTranslation: TransactionIdLabelTranslation): Array<TranslationSection> {
    const infoSection = new TranslationSection();

    const TransactionIDLabel = new TranslationField();
    TransactionIDLabel.key = 'Admin.CloudIntegration.TransactionIdLabel';
    TransactionIDLabel.defaultValue = TransactionIdLabelTranslation.translatedValue;
    TransactionIDLabel.maxlength = 120;
    TransactionIDLabel.idPrefix = 'quoteOrderIdLabel_';
    TransactionIDLabel.namePrefix = 'quoteOrderIdLabel_';
    infoSection.translationFields = [TransactionIDLabel];
    return [infoSection];
  }

  public fillTranslations(translations: TransactionIdLabelTranslation, translationSections: Array<TranslationSection>): Array<TranslationSection> {
    if (translations) {
      translationSections.forEach(section => {
        section.translationFields.forEach(translationField => {
          translationField.translations[translations.dictionaryId] = translations.translatedValue;
        });
      });
    }
    return translationSections;
  }
}
